import React from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
  Typography,
  IconButton,
} from "@mui/material";
import DvrIcon from "@mui/icons-material/Dvr";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { DataGrid } from "@mui/x-data-grid";
import { durationList, sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  getScenarioChartData,
  getScenarios,
  setState,
  getAnalyzeTradeProducts,
  getAnalyzeTradeForm,
  getAnalyzeTradeStrength,
  getProductQuota,
  exportFile_TradeDetails,
  getAnalyzeCustomername,
  GetAnalyzeIntendDeliveredChart,
  getSkuPg,
  getCustomers,
  getSkuPgForScenario,
} from "../analyzeSlice";
import _ from "lodash";
import ReactApexChart from "react-apexcharts";

import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";
import MultiSelectCustomers from "./MultiSelectCustomers";
import MultiSelectskus from "./MultiSelectskus";
import CollapseSection from "../../../components/ui/CollapseSection";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function IntendedVSDelivered() {
  const [validate, setValidate] = useState({
    countryValidated: false,
    scenarioValidated: false,
    productValidated: false,
    customerValidated: false,
    durationValidated: false,
  });
  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const [countryIVD, setCountryIVD] = useState("");
  const [scenarioIVD, setScenarioIVD] = useState("");

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const loginState = useSelector((store) => store.login);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    scenarios,
    selectedScenarioName,
    selectedScenarioID,
    selectedProductName,
    tradeProducts,
    tradeForms,
    tradeStrength,
    selectedTradeProduct,
    selectedTradeForm,
    selectedTradeStrength,
    selectedTradeForms,
    selectedTradeStrengths,
    selectedAnalysisTypeID,
    selectedDataCustomerIds,
    customerIVDList,
    duration,
    productQuota,
    getAnalyzeCustomerNames,
    customers,
    selectedCustomers,
    getIDChartData,
    isActiveScenario,
    skuPgs,
    selectedSkuPgName,
    selectedSkuPgID,
    clearAnalyzeIVD,
    selectedDataskuIds,
  } = state;

  let skuPgsArr = skuPgs.filter((item) => item.packGroupOrSKUName !== "All");

  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;

  useEffect(() => {
    if (scenarioIVD !== "") {
      getSkuPgForScenario();
    }
  }, [scenarioIVD]);

  function getSkuPgForScenario() {
    const scenarioID = selectedScenarioID;
    const obj = {
      scenarioID,
    };
    dispatch(getSkuPg(obj));
    dispatch(getCustomers(obj));
  }

  // let options = []
  // if(!_.isEmpty(getAnalyzeCustomerNames)){
  // 	 options = _.cloneDeep(getAnalyzeCustomerNames);
  // }
  useEffect(() => {
    if (countryIVD !== "") {
      getScenariosForCountry();
    }
  }, [countryIVD]);

  function getScenariosForCountry() {
    const countryID = selectedCountryID;
    const activeScenario = isActiveScenario;
    const analyisID = selectedAnalysisTypeID;
    const obj = {
      countryID,
      activeScenario,
      analyisID,
    };
    dispatch(getScenarios(obj));
  }

  const chartData = {
    options: {
      chart: {
        id: "column-chart",
        type: "bar",
        height: 350,
      },
      xaxis: {
        categories: getIDChartData.map((item) => item.period),
        title: {
          text: "Period",
        },
      },
      yaxis: {
        title: {
          text: "Intended vs Delivered",
        },
        labels: {
          formatter: (value) => {
            const formatter = new Intl.NumberFormat("en-US");
            return formatter.format(value);
          },
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (value) => {
          const formatter = new Intl.NumberFormat("en-US");
          return formatter.format(value);
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            const formatter = new Intl.NumberFormat("en-US");
            const roundedValue = Math.round(val);
            return formatter.format(roundedValue);
          },
        },
      },
      colors: ["#d3d3d3", "#3366cc"],
    },

    series: [
      {
        name: "Intended",
        data: getIDChartData.map((item) => item.intendedConsumption),
      },
      {
        name: "Delivered",
        data: getIDChartData.map((item) => item.originalActualConsumption),
      },
    ],
  };

  useEffect(() => {
    dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedSkuPgName", ""));
    dispatch(setState("duration", null));
    dispatch(setState("clearIVDValues", true));
    dispatch(setState("clearAnalyzeIVD", false));
    dispatch(setState("selectedDataCustomerIds", []));
    dispatch(setState("customerIVDList",[]));

    dispatch(setState("scenarios", []));
    dispatch(setState("skuPgs", []));
    dispatch(setState("customers", []));

  }, []);

  const clearValuesForCountry = () => {
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedSkuPgName", ""));
    dispatch(setState("clearIVDValues", true));
  };

  const clearValuesForScenario = () => {
    dispatch(setState("selectedSkuPgName", ""));
    dispatch(setState("clearIVDValues", true));
  };

  const clearValuesForProduct = () => {
    dispatch(setState("clearIVDValues", true));
  };

  function setCountry(event) {
    const name = event.target.value;
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;
    if (name) {
      setValidate({
        ...validate,
        countryValidated: true,
      });
    }
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));

    setCountryIVD(name);

    clearValuesForCountry();

    dispatch(setState("clearAnalyzeIVD", false));
  }

  useEffect(() => {
    if (globalSelectedCountryID !== null) {
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
    }
  }, [globalSelectedCountryID]);

  useEffect(() => {
    if (globalSelectedCountryName !== null) {
      dispatch(setState("selectedCountry", globalSelectedCountryName));
    }
  }, [globalSelectedCountryName]);

  // function getScenariosForCountry() {
  // 	const countryID = selectedCountryID;
  // 	const activeScenario = false;
  // 	const analyisID = selectedAnalysisTypeID;
  // 	const obj = {
  // 		countryID,
  // 		activeScenario,
  // 		analyisID,
  // 	};
  // 	dispatch(getScenarios(obj));
  // }

  function setProduct(event) {
    const name = event.target.value;
    if (name) {
      setValidate({
        ...validate,
        productValidated: true,
      });
    }
    dispatch(setState("selectedTradeProduct", name));
    //dispatch(setState("selectedCountryID", countryID));

    clearValuesForProduct();
  }

  function getProductsForSelectedCountry() {
    const countryID = selectedCountryID;
    const activeScenario = false;
    const analyisID = selectedAnalysisTypeID;
    const obj = {
      countryID,
      //activeScenario,
      //analyisID,
    };
    dispatch(getAnalyzeTradeProducts(obj));
  }

  function getForms() {
    const countryID = selectedCountryID;
    const productName = selectedTradeProduct;
    const obj = {
      countryID,
      productName,
    };
    dispatch(getAnalyzeTradeForm(obj));
  }

  function getStrengths() {
    const countryID = selectedCountryID;
    const productName = selectedTradeProduct;
    const formsType = [];
    formsType.push(selectedTradeForm);
    const obj = {
      countryID,
      productName,
      formsType,
    };
    dispatch(getAnalyzeTradeStrength(obj));
  }

  function getAnalyzeCustomerName() {
    const CountryID = selectedCountryID;
    const ProductName = selectedSkuPgName;
    const ScenarioId = selectedScenarioID;
    const Duration = duration;
    const obj = {
      CountryID,
      ProductName,
      ScenarioId,
      Duration,
    };
    dispatch(getAnalyzeCustomername(obj));
  }

  function handleTradeForms(e) {
    //console.log(values);
    const formName = e.target.value;
    dispatch(setState("selectedTradeForm", formName));
  }

  function handleTradeStrengths(e) {
    const strengthName = e.target.value;
    dispatch(setState("selectedTradeStrength", strengthName));
  }

  function setDuration(event) {
    const d = event.target.value;
    if (d) {
      setValidate({
        ...validate,
        durationValidated: true,
      });
    }
    dispatch(setState("duration", d));
  }

  // function setScenario(event) {
  // 	const name = event.target.value;
  // 	const id = scenarios.find(
  // 		(scenario) => scenario.scenarioName === name
  // 	).scenarioID;
  // 	if(name){
  // 		setValidate({
  // 			...validate, scenarioValidated:true
  // 		})
  // 	}
  // 	dispatch(setState("selectedScenarioName", name));
  // 	dispatch(setState("selectedScenarioID", id));
  // }

  // useEffect(() => {
  //   if (countryIVD !== "") {
  //     getProductsForSelectedCountry();
  //   }
  // }, [countryIVD]);

  // useEffect(() => {
  //   if (selectedTradeProduct !== "") {
  //     getForms();
  //   }
  // }, [selectedTradeProduct]);

  // useEffect(() => {
  //   if (selectedTradeForm !== "") {
  //     getStrengths();
  //   }
  // }, [selectedTradeForm]);

  useEffect(() => {
    if (
      duration !== null &&
      selectedSkuPgName !== "" &&
      selectedScenarioID !== "" &&
      selectedCountryID !== ""
    ) {
      getAnalyzeCustomerName();
    }
  }, [selectedCountryID, selectedTradeProduct, selectedScenarioID, duration]);

  // useEffect(() => {
  // 	//Check if any of the dropdown are false and then set alertDisplay to false
  // 	const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

  // 	if (isAnyKeyValueFalse(validate)) {
  // 		setAlert({ ...Alert, alertDisplay: false });
  // 	}
  // }, [validate])

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [2000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  useEffect(() => {
    if (
      productQuota !== null &&
      productQuota !== undefined &&
      !_.isEmpty(productQuota)
    ) {
      // Extract column definitions from keys
      const columns = Object?.keys(productQuota?.analyzeTradeDetails[0])?.map(
        (key) => ({
          field: key,
          headerName:
            key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " "),
          flex: 1,
          minWidth: 100,
        })
      );

      // Map the array of data to rows
      const rows = productQuota?.analyzeTradeDetails.map((item, index) => ({
        id: index,
        ...item,
      }));

      setRows(rows);
      setColumns(columns);
    }
  }, [productQuota]);

  function exportDataAsFile(isPdf) {
    const obj = {
      isPdf,
      Type: "TradeDetails",
      AnalyzeTitle: "Analyze: Trade Details",
      CountryID: selectedCountryID,
      CountryName: selectedCountry,
      Duration: duration,
      listAnalyseData: rows,
    };
    dispatch(exportFile_TradeDetails(obj));
  }

  // const handleSelectAll = () => {
  // 	if (selectAll) {
  // 		setSelectedOptions([]);
  // 	} else {
  // 		setSelectedOptions(options);
  // 	}
  // 	setSelectAll(!selectAll);
  // };

  // const handleChange = (event) => {
  // 	setSelectedOptions(event.target.value);
  // };

  // const handleSearch = (event) => {
  // 	setSearchText(event.target.value);
  // };

  // const filteredOptions = options?.filter((option) =>
  // 	option.customerName.toLowerCase().includes(searchText.toLowerCase())
  // );

  function setScenario(event) {
    const id = event.target.value;
    const name = scenarios.find(
      (scenario) => scenario.scenarioID === id
    ).scenarioName;
    if (name) {
      setValidate({
        ...validate,
        scenarioValidated: true,
      });
    }
    dispatch(setState("selectedScenarioName", name));
    dispatch(setState("selectedScenarioID", id));

    setScenarioIVD(id);

    clearValuesForScenario();
  }

  function setSkuPg(event) {
    const name = event.target.value;
    let id = 0;
    console.log(skuPgsArr);
    if (name !== "All") {
      id = skuPgsArr.find(
        (skuPg) => skuPg.packGroupOrSKUName === name
      ).packGroupOrSKUID;
      console.log(id);
    }
    if (name) {
      setValidate({
        ...validate,
        productValidated: true,
      });
    }
    dispatch(setState("selectedSkuPgName", name));
    dispatch(setState("selectedSkuPgID", id));

    clearValuesForProduct();
  }
  const getCustomerIdsFromNames = (customerNames) => {
		// const customerIds = customerNames.map((name) => {
		//   const customer = customersData.find((option) => option.customerName === name);
		//   return customer ? customer.customerID : null;
		// });
		// return customerIds.filter((id) => id !== null);

		const uniqueKeys = new Map();
		for (const item of customers) {
			const key = `${item.customerName}`;
			uniqueKeys.set(key, item.customerID);
		}
		
		const customerIds = [];
		
		for (const item of customerNames) {
			const key = `${item}`;
			if (uniqueKeys.has(key)) {
				customerIds.push(uniqueKeys.get(key));
			} else {
				customerIds.push(item);
			}
		}
		return customerIds.filter((id) => id !== null);

	};

  function handleDisplay() {
    if (selectedCountry === null || selectedCountry === "") {
      displayAlert("Country");
      return;
    }
    if (selectedScenarioName === null || selectedScenarioName === "") {
      displayAlert("Scenario");
      return;
    }
    if (selectedDataskuIds === null || selectedDataskuIds.length === 0) {
      displayAlert("SKU Name");
      return;
    }
    if (duration === null || duration === "") {
      displayAlert("Duration");
      return;
    }
    if (
      customerIVDList.length === 0 ||
      customerIVDList === null
    ) {
      displayAlert("Customer");
      return;
    }
    let ids = [];
    if (customerIVDList.length > 0) {
      ids = getCustomerIdsFromNames(customerIVDList);
      //dispatch(setState("clearDataValues", false));
    }
    else {
      ids = [];
    }
		dispatch(setState("selectedDataCustomerIds", ids));
    const obj = {
      scenarioID: selectedScenarioID,
      skuPGId: selectedDataskuIds,
      countryID: selectedCountryID,
      //formsType: formsType,
      duration: duration,
      //strength: strength,
      customerID: ids,
    };

    dispatch(setState("clearAnalyzeIVD", true));

    dispatch(GetAnalyzeIntendDeliveredChart(obj));
  }

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Grid
          container
          // columns={12}
          spacing={2}
        >
          <Grid
            item
            sx={{ minWidth: "200px" }}
            // sm={6} md={4} lg={2}
          >
            <FormControl>
              <InputLabel>Country</InputLabel>
              <Select
                value={countryIVD}
                label="Country"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                size="small"
                onChange={setCountry}
              >
                {countries?.map((country, index) => {
                  return (
                    <MenuItem key={index} value={country.countryName}>
                      {country.countryName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            sx={{ minWidth: "220px" }}
            // sm={6} md={4} lg={2}
          >
            <FormControl>
              <InputLabel>Scenario</InputLabel>
              <Select
                value={scenarioIVD}
                label="Scenario"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                onChange={setScenario}
              >
                {scenarios.map((scenario, index) => {
                  return (
                    <MenuItem key={index} value={scenario.scenarioID}>
                      {scenario.scenarioName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid item sx={{ minWidth: "200px" }}>
            <MultiSelectskus skus={skuPgsArr} />
            {/* <FormControl>
              <InputLabel>Product</InputLabel>
              <Select
                value={selectedSkuPgName}
                label="Product"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                onChange={setSkuPg}
              >
                <MenuItem value="All">All</MenuItem>
                {skuPgsArr?.map((skuPg, index) => {
                  return (
                    <MenuItem key={index} value={skuPg.packGroupOrSKUName}>
                      {skuPg.packGroupOrSKUName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl> */}

            {/* <FormControl>
							<InputLabel>Product Name</InputLabel>
							<Select
								value={selectedTradeProduct}
								label="Product Name"
								sx={{
									height: selectHeight,
									width: selectWidth,
									color: "black.main",
									mt: 1
								}}
								size="small"
								onChange={setProduct}
							>
								{tradeProducts?.map((product, index) => {
									return (
										<MenuItem key={index} value={product}>
											{product}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl> */}
          </Grid>

          {/* <Grid item>
						<Autocomplete
							multiple
							id="tradeForms"
							size="small"
							options={tradeForms}
							getOptionLabel={(option) => option}
							defaultValue={[]}
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								//mt:1
							}}
							onChange={(event, values) => handleTradeForms(values)}
							renderInput={(params) => (
								<TextField
									{...params}
									variant="standard"
									size="small"
									label="Form"
									placeholder=""
								/>
							)}
						/>
					</Grid> */}

          {/* <Grid item>
						<FormControl>
							<InputLabel>Form</InputLabel>
							<Select
								value={selectedTradeForm}
								label="Form"
								sx={{
									height: selectHeight,
									width: selectWidth,
									color: "black.main",
									mt: 1
								}}
								size="small"
								onChange={handleTradeForms}
							>
								{tradeForms?.map((form, index) => {
									return (
										<MenuItem key={index} value={form}>
											{form}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Grid>


					<Grid item>
						<FormControl>
							<InputLabel>Strength</InputLabel>
							<Select
								value={selectedTradeStrength}
								label="Strength"
								sx={{
									height: selectHeight,
									width: selectWidth,
									color: "black.main",
									mt: 1
								}}
								size="small"
								onChange={handleTradeStrengths}
							>
								{tradeStrength?.map((strength, index) => {
									return (
										<MenuItem key={index} value={strength}>
											{strength}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Grid> */}

          {/* <Grid item>
						<Autocomplete
							multiple
							id="tradeStrengths"
							size="small"
							options={tradeStrength}
							getOptionLabel={(option) => option}
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								//mt:1
							}}
							defaultValue={[]}
							onChange={(event, values) => handleTradeStrengths(values)}
							renderInput={(params) => (
								<TextField
									{...params}
									variant="standard"
									size="small"
									label="Strength"
									placeholder=""
								/>
							)}
						/>
					</Grid> */}

          <Grid
            item
            // sm={6} md={4} lg={2}
            sx={{ minWidth: "260px" }}
          >
            <MultiSelectCustomers customers={customers} />
          </Grid>
          <Grid
            item
            // sm={6} md={4} lg={2}
          >
            <FormControl>
              <InputLabel>Duration</InputLabel>
              <Select
                value={duration}
                label="Duration"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                onChange={setDuration}
              >
                {durationList.map((duration, index) => {
                  return (
                    <MenuItem key={index} value={duration.value}>
                      {duration.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={6} md={4} lg={1}>
            <Button
              startIcon={<DvrIcon />}
              sx={{
                bgcolor: "blue.main",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
                },
                //mt: 1.5
              }}
              onClick={handleDisplay}
            >
              Display
            </Button>
          </Grid>
        </Grid>
        {alert.alertDisplay && (
          <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
        )}
      </Box>

      {clearAnalyzeIVD && getIDChartData?.length > 0 && (
        <>
          <CollapseSection title="Intended vs Delivered Chart Data">
            <Box sx={{ mt: 3 }}>
              <div className="chart">
                <ReactApexChart
                  options={chartData.options}
                  series={chartData.series}
                  type="bar"
                  height={400}
                />
              </div>
            </Box>
          </CollapseSection>
        </>
      )}
    </>
  );
}
